import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/origin.svg'


const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('help.title')), 1),
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('help.intro')) + " ", 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('help.dataTitle')), 1),
        _createElementVNode("ol", null, [
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('help.point1')) + " ", 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('help.point1_sub1')), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('help.point1_sub2')), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('help.point2_pre')) + " ", 1),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              width: "25px"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('help.point2_post')), 1)
          ]),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('help.point3')), 1),
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('help.point4')) + " ", 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('help.point4_sub1')), 1),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('help.point4_sub2_pre')) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('help.point4_sub2_btn')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('help.point4_sub2_post')), 1)
              ])
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('help.point4_end')), 1)
          ])
        ])
      ])
    ])
  ]))
}